export interface DepartmentActionTypes {
  type: DepartmentActions;
  payload?: any;
}

export enum DepartmentActions {
  CREATE_DEPARTMENT = "CREATE_DEPARTMENT",
  GET_DEPARTMENT_LIST = "GET_DEPARTMENT_LIST",
  SET_DEPARTMENT_LIST = "SET_DEPARTMENT_LIST",
  SET_DEPARTMENT_LIST_PAGE_COUNT = "SET_DEPARTMENT_LIST_PAGE_COUNT",
  GET_DEPARTMENT_DATA_BY_ID = "GET_DEPARTMENT_DATA_BY_ID",
  SET_DEPARTMENT_DATA_BY_ID = "SET_DEPARTMENT_DATA_BY_ID",
  EDIT_DEPARTMENT_DATA_BY_ID = "EDIT_DEPARTMENT_DATA_BY_ID",
}
